<template>
    <div class="productDetail" data-aos="fade-up" data-aos-duration="1000">
        <div style="min-height: 5.6rem;"></div>
        <div class="top">
            <span class="back" @click="handleBack">
                <i class="el-icon-back"></i>
                返回
            </span>
            <h3>智能采血系统</h3>
            <span ></span>
        </div>
        <div class="model">AT-WTC240</div>
        <section class="pro">
            <div class="img">
                <img  src="/imgs/product/third/cxxt/240_product_details_cxxt.png" alt="">
            </div>
            <div class="title" >
                <h1>智能采血系统AT-WTC240</h1>
                <p>单机并联流水线，岗位独立操作互不影响</p>
            </div>
        </section>

        <section class="concept">
            <div class="concept-title">
                <div class="title">
                    <span></span>
                    <h3>产品优势</h3>
                </div>
            </div>
            <div class="concept-content" >
                <div>
                    <img  src="/imgs/product/third/cxxt/240_cxxt_icon_a.png" alt="" />
                    <div>体积小</div>
                    <p>体积小巧，灵活摆放</p>
                </div>
                <div>
                    <img  src="/imgs/product/third/cxxt/240_cxxt_icon_b.png" alt="" />
                    <div>备管快</div>
                    <p>备管快，仅需2.5秒 </p>
                    </div>
                <div>
                    <img  src="/imgs/product/third/cxxt/240_cxxt_icon_c.png" alt="" />
                    <div>容量大</div>
                    <p>8种管，240支，容量大</p>
                </div>

                <div>
                    <img  src="/imgs/product/third/cxxt/240_cxxt_icon_d.png" alt="" />
                    <div>易操作</div>
                    <p>一键打印，操作简单</p>
                </div>

            </div>
        </section>
        <div class="concept-foot">
            <img src="/imgs/product/third/cxxt/240_product_details_cxxt_foot.png" alt="" />
        </div>
    </div>
</template>
<script>
export default {
    name: "cxc",
    components: {},
    data() {
        return {
            productType: '',
            nav: '',
            savedScrollPosition: 0,
        };
    },
    methods: {
        handleBack(){
            if (this.productType && this.nav) {
                // 使用$router.push回到指定页面，并传递参数
                this.$router.push({
                    path: "/" + this.nav,
                    query: {
                        productType: this.productType,
                        scrollPosition: this.savedScrollPosition,
                    },
                });
            } else {
                this.$router.go(-1);  
            }
        },
    },
    created() {
        document.title = "深圳市傲天医疗智能系统有限公司-智能采血秤"
    },
    mounted() {
        // 检查URL参数
        const params = new URLSearchParams(window.location.search);
        const productTypeValue = params.get('productType');
        const navValue = params.get('nav');
        const savedScrollPositionValue = params.get('scrollPosition');
        // 如果有参数，则更改显示
        if (productTypeValue && navValue) {
            this.productType = productTypeValue;
            this.nav = navValue;
        };
        if(savedScrollPositionValue){
            this.savedScrollPosition = savedScrollPositionValue;
        };
    },
    beforeUnmount() {},
    watch: {
        
    },
};
</script>
<style lang="less" scoped>
.productDetail{
    background: #F9F9F9;
    .top{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 67rem;
        max-width: calc(100vw - 40px);
        margin: 0 auto;
        padding-top:2rem;
        padding-bottom: 0.5rem;
        .back{
            color: #666666;
            cursor: pointer;
            font-size: 0.88rem;
            &:hover{
                color: #0F45F9;
            }
        }
        >span{
            min-width: 3rem;
            display: block;
        }
        >h3{
            font-size: 1.22rem;
            text-align: center;
            margin: 0;
            padding: 0;
        }
    }
    .model{
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        margin: 0 auto;
        padding-bottom: 1rem;
    }
    .title {
        display: flex;
        flex-direction: column;
        align-items: center;
        > h3 {
            margin: 0;
            font-size: 2.6rem;
        }
        > span {
            display: block;
            width: 5.6rem;
            height: 0.4rem;
            background: #0f45f9;
            margin-bottom: 1rem;
        }
        > p {
            font-size: 1.33rem;
        }
    }
    .pro{
        width: 100vw;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items:center;
        justify-content: center;
        .title{
            text-align: center;
            margin:0 5rem;
            width: 30rem;
            padding: 7.7rem 0 0 0;
            h1{
                font-size: 2.44rem;
                min-width: 20rem;
                margin: 0;
                white-space:nowrap;
            }
            p{
                font-size: 1.3rem;
                color: #666666;
            }

        }
        .img{
            >img{
                width: 100vw;
                object-fit: contain;
            }
        }
    }
    .concept{
        width: 67rem;
        max-width: 100vw;
        margin: 0 auto;
        padding: 2rem 0;
        .concept-title{
            margin-bottom: 3.3rem;
        }
        .concept-content{
            width: 100%;
            position: relative;
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
            >div{
                width: 33.5rem;
                max-width: calc(50vw - 20px);
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 2rem 0;
                >div{
                    font-size: 1.5rem;
                    margin-bottom: 1rem;
                }
                >p{
                    font-size: 1.3rem;
                    color: #666666;
                    margin: 0.3rem 0.5rem;
                }
                >img{
                    width: 4.8rem;
                }
            }
        }
    }
    .concept-foot{
        display: flex;
        padding-bottom: 5rem;
        >img{
            width: 100vw;
            object-fit: contain;
        }
    }
}
</style>
